var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13zm8.5-6.5a8.5 8.5 0 11-17.001-.001A8.5 8.5 0 0119 10.5z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.293 22.707l-6-6 1.414-1.414 6 6-1.414 1.414z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgICAgZD0iTTEwLjUgMTdjMy41OSAwIDYuNS0yLjkxIDYuNS02LjVTMTQuMDkgNCAxMC41IDQgNCA2LjkxIDQgMTAuNSA2LjkxIDE3IDEwLjUgMTd6bTguNS02LjVjMCA0LjY5NC0zLjgwNiA4LjUtOC41IDguNVMyIDE1LjE5NCAyIDEwLjUgNS44MDYgMiAxMC41IDIgMTkgNS44MDYgMTkgMTAuNXoiCiAgICAgICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMjEuMjkzIDIyLjcwN2wtNi02IDEuNDE0LTEuNDE0IDYgNi0xLjQxNCAxLjQxNHoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };